import classNames from 'classnames';
const footerCss = "f1q8cgdl";
const actionsCss = "a1ovpag8";

/** Shared split footer layout for a leading action and grouped form actions. */
export const SettingsFormFooter = ({
  leadingAction,
  children,
  className
}) => <div className={classNames(footerCss, className)}>
    {leadingAction}
    <div className={actionsCss}>{children}</div>
  </div>;

require("./settings-form-footer.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./settings-form-footer.js");